export const SNAPSHOTS = 'snapshots';
export const CAROUSEL = 'carousel';

export const viewModes = {
  [SNAPSHOTS]: {value: SNAPSHOTS, label: 'Show all'},
  [CAROUSEL]: {value: CAROUSEL, label: 'Carousel'}
}
